import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, ButtonGroup, Typography, Box, Fab, Badge, Divider, Tooltip } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { formatDateTime, formatMinutosHoras, isColorDark, obtenerFechaHoraSQL } from '../../../utils/utils';
import { actualizarTarea, eliminarTarea, updateTarea } from '../../../services/apis';
import InfoIcon from '@mui/icons-material/Info';
import { TareaDialog } from './TareaDialog';
import { FormEditarTarea } from './FormEditarTareay';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import CreateIcon from '@mui/icons-material/Create';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import { advertenciaEliminar } from '../../../utils/componentes-utiles/advertencias';
import { AlertError } from '../../../utils/componentes-utiles/AlertError';
import CircleIcon from '@mui/icons-material/Circle';

export const TareaCard = ({ tarea, opciones, estados, cargarTareas, opclientes, opTrabajadores, tiposDeTarea, opcionesTipoTareas }) => {

    const [tareaInfo, setTareaInfo] = useState(tarea);
    const [tareaEditar, setTareaEditar] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [backgroundCard, setBackgroundCArd] = useState(estados.find(estado => estado.id === tareaInfo.id_estado).color);
    const [tipoTarea, setTipoTarea] = useState(tiposDeTarea.find(tipoTarea => tipoTarea.id === tareaInfo.id_tipo_tarea));

    const [textColor, setTextColor] = useState(isColorDark(tareaInfo.estado_color) ? '#FFFFFF' : '#000000');
    const [errorAlert, setErrorAlert] = useState(false);
    const [horasTotales, setHorasTotales] = useState(0);
    const [validar, setValidar] = useState(false);
    const [colorTipoTarea, setColorTipoTarea] = useState(tipoTarea ? tipoTarea.color : '#00000f');


    //cambiar dinamicamente el color del fondo de la tarjeta
    useEffect(() => {
        setTextColor(isColorDark(estados.find(estado => estado.id == tareaInfo.id_estado).color) ? '#FFFFFF' : '#000000');
        setBackgroundCArd(estados.find(estado => estado.id == tareaInfo.id_estado).color);
    }, [tareaInfo.id_estado]);

    useEffect(() => {
        setTareaInfo(tarea);
    }, [tarea])

    const iconMapping = {
        DoneAllIcon: <DoneAllIcon sx={{ ml: 0.5 }} />,
        PlayArrowIcon: <PlayArrowIcon sx={{ ml: 0.5 }} />,
        PauseIcon: <PauseIcon sx={{ ml: 0.5 }} />,
        EditIcon: <EditIcon sx={{ ml: 0.5 }} />,
        CreateIcon: <CreateIcon sx={{ ml: 0.5 }} />,
        DeleteForeverIcon: <DeleteForeverIcon sx={{ ml: 0.5 }} />,
        FactCheckIcon: <FactCheckIcon sx={{ ml: 0.5 }} />
    };
    const handleEvent = (opcionId) => {
        switch (opcionId) {
            case 1:
                handleOnChange({ id_estado: 1 })
                // Lógica para la opción 1
                break;
            case 2:
                handleOnChange({ id_estado: 2 })
                // Lógica para la opción 2
                break;
            case 3:
                if (opcionId === 3 && tareaInfo.horas_totales < 15) {
                    setErrorAlert(true);
                }
                else {
                    handleOnChange({ id_estado: 3 })

                }

                // Lógica para la opción 3
                break;
            case 4:
                setValidar(true)
                // handleOnChange({ id_estado: 4 })
                // Lógica para la opción 4
                break;
            case 50:
                setTareaEditar(true);
                break;
            case 51:
                eliminarTareaF(tareaInfo.id);
                break;
            case 90:
                // Lógica para la opción 4
                break;
            default:
                console.log("Lógica para una opción desconocida");
                // Lógica para una opción desconocida
                break;
        }
    }

    const activarBoton = (opcion, infoTarea) => {

        switch (opcion.id_estado) {
            case 50:
                if (infoTarea.id_estado === 4) {
                    return true;
                } else {
                    return false;
                }
            case 1:
                if (infoTarea.id_estado === 0 || infoTarea.id_estado === 2 || !infoTarea.userencurso) {
                    return false;
                } else {
                    return true;
                }
            case 2:
                if (infoTarea.id_estado === 1 && infoTarea.userencurso) {

                    return false;
                } else {
                    return true;
                }

            case 3:
                if (infoTarea.id_estado === 0 || infoTarea.id_estado === 1 || infoTarea.id_estado === 2) {
                    return false;
                } else {
                    return true;
                }
            case 4:
                if (infoTarea.id_estado === 3 || infoTarea.id_estado === 4) {
                    return false;
                } else {
                    return true;
                }

            case 51:
                if (infoTarea.id_estado === 4) {
                    return true;
                } else {
                    return false;
                }
            default:
                return true;
        }
    }



    const handleOnChange = (data) => {        
        // Crear una copia del objeto tarea
        let temp = { ...tareaInfo };
        // Obtener la clave y el valor del objeto data
        const [key, value] = Object.entries(data)[0];

        // Verificar si la clave existe en el objeto tarea
        if (temp.hasOwnProperty(key)) {
            // Cambiar el valor del elemento que coincide
            temp[key] = value;
        }
        // Actualizar el estado de tarea con el nuevo objeto modificado
        // Suponiendo que estás usando useState para manejar el estado de tarea
        // setTareaInfo(temp); si se deja activo da la falsa ilusion de que laggea
        console.log("TEMPPPPPPPPPPPPPPPPPPPPPP",temp);
        
        actualizarTareaEstado(temp);
        // Para fines de depuración
    };

    const actualizarTareaEstado = (data) => {
        let temp = { ...data };
        temp.fechaActual = obtenerFechaHoraSQL();
        actualizarTarea(temp).then(() => {
            cargarTareas(); // Se ejecuta después de que actualizarTarea se completa
        })
    }



    const eliminarTareaF = async (id) => {
        const titulo = "Eliminar Tarea " + tareaInfo.id;
        const texto = "Vas a eliminar permanentemente esta tarea";

        // Asegúrate de esperar el resultado de advertenciaEliminar
        const confirmado = await advertenciaEliminar(titulo, texto);
        if (confirmado) {
            try {
                const response = await eliminarTarea(id)
                if (response.success == true) {
                    cargarTareas();
                }
            }
            catch (error) {
                console.error("Error al eliminar la tarea:", error);

            }
        }

    };
    useEffect(() => {
        const nuevoTipoTarea = tiposDeTarea.find(tipo => tipo.id === tareaInfo.id_tipo_tarea);
        setTipoTarea(nuevoTipoTarea);
        setColorTipoTarea(nuevoTipoTarea ? nuevoTipoTarea.color : '#00000f');

    }, [tareaInfo.id_tipo_tarea, tiposDeTarea]);


    return (
        <Grid
            container
            direction="column"
            justifyContent="start"
            alignItems="center"
            xs={12}
            fontWeight={500}
            padding={2}
            style={{
                backgroundColor: "#" + backgroundCard,
                color: textColor,
                minHeight: '40vh',
                maxHeight: '100vh',
            }}
            className="tarea-card fade-in2"
        >
            <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
                xs={12}
            >
                <Grid
                    container
                    direction="row"
                    justifyContent="space-between"
                    alignItems="start"
                    xs={11.5}
                    sx={{
                        minHeight: '7vh',
                        maxHeight: '20vh',
                        // backgroundColor: 'red'
                    }}
                >
                    <Typography variant="body1">
                        Tarea: {tareaInfo.id}
                    </Typography>
                    {tipoTarea && (
                        <Grid item xs={1.5} onClick={() => setOpen(true)} className='pointer'>
                            <Tooltip title={tipoTarea.nombre} placement="top">
                                < CircleIcon sx={{
                                    color: colorTipoTarea,
                                }} />
                            </Tooltip>
                        </Grid>
                    )}

                    <Grid item xs={1.5} onClick={() => setOpen(true)} className='pointer'>
                        <Badge badgeContent={tareaInfo.comentarios.total_comentarios} color="primary">
                            <InfoIcon sx={{ fontSize: 30, marginBottom: 2 }} />
                        </Badge>
                    </Grid>
                    <Grid
                        container
                        direction="row"
                        justifyContent="space-between"
                        alignItems="start"
                        xs={12}

                    >
                        {tareaInfo.nombre_proyecto && (
                            <Typography
                                variant="body1"
                                sx={{
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    display: '-webkit-box',
                                    WebkitLineClamp: 1,
                                    WebkitBoxOrient: 'vertical',
                                    fontWeight: 700,
                                    textDecoration: 'underline',
                                    textDecorationColor: 'var(--principal)',
                                }}
                            >
                                {tareaInfo.nombre_proyecto}
                            </Typography>
                        )}
                    </Grid>
                    <Grid item xs={12} textAlign={'left'} >
                        <Typography variant="body1"
                            sx={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                display: '-webkit-box',
                                WebkitLineClamp: 1, // Limita el número de líneas
                                WebkitBoxOrient: 'vertical',
                                fontWeight: 700,
                            }}
                        >

                            {tareaInfo.cliente}
                        </Typography>
                    </Grid>

                    <Grid
                        container
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        xs={12}
                        gap={1}
                        sx={{ mt: 0 }}
                    >
                        <Grid item xs={6} style={{
                            textAlign: 'left',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: 'inline-block',
                            whiteSpace: 'nowrap',
                        }} >
                            <Typography variant="caption" >
                                {tareaInfo.correo}
                            </Typography>
                        </Grid>

                        <Grid item xs={4} style={{ textAlign: 'right' }}>
                            <Typography variant="caption">
                                {formatDateTime(tareaInfo.fecha)}
                            </Typography>
                        </Grid>
                    </Grid>

                </Grid>
            </Grid>

            <Grid
                container
                direction="column"
                justifyContent="start"
                alignItems="start"
                xs={11.5}
                sx={{
                    // backgroundColor: 'red',
                    minHeight: '10vh',
                    maxHeight: '20vh',
                }}
            >
                <Typography variant="h6" gutterBottom textAlign={'left'} className='lineas-max-2'>
                    {tareaInfo.asunto}
                </Typography>
                <Grid container xs={12} justifyContent="start" alignItems="start">
                    <Typography variant="body2" gutterBottom textAlign={'left'} className='lineas-max-2'>
                        {tareaInfo.segunda_referencia ? tareaInfo.segunda_referencia : ''}
                    </Typography>
                </Grid>
                <Grid container xs={12} justifyContent="start" alignItems="start">
                    <Typography variant="body2" gutterBottom textAlign={'left'} className='lineas-max-2'>
                        {tareaInfo.descripcion}
                    </Typography>
                </Grid>


            </Grid>

            <Grid
                container
                direction="column"
                justifyContent="start"
                alignItems="start"
                xs={11.5}
                style={{
                    // backgroundColor: 'red',
                    minHeight: '6vh',
                    maxHeight: '15vh',
                    marginTop: 6
                }}
            >
                {tareaInfo.trabajadores.length > 0 && (
                    <Grid
                        container
                        direction="row"
                        justifyContent="start"
                        alignItems="start"
                        xs={12}
                    >
                        {tareaInfo.trabajadores.length > 0 && (
                            <Grid container xs={12} direction="row" justifyContent="start" alignItems="start">
                                <Grid container xs={12} direction="row" justifyContent="start" alignItems="start" >
                                    <Typography variant="subtitle2" gutterBottom>
                                        Asignado a:&nbsp;
                                        {(tareaInfo.trabajadores.slice(0, 3)).map((trabajador, index) => (
                                            <span>{trabajador.label}&nbsp;</span>
                                        ))}
                                    </Typography>
                                </Grid>


                                <>
                                    {tareaInfo.trabajadores.length > 3 && (
                                        <Typography variant="caption" gutterBottom sx={{ fontWeight: 600 }}>
                                            y mas...
                                        </Typography>
                                    )}
                                </>
                            </Grid>
                        )}
                    </Grid>
                )}



                {tareaInfo.usuarios_con_tiempo.length > 0 && (
                    <Grid
                        container
                        direction="row"
                        justifyContent="start"
                        alignItems="start"
                        xs={12}
                    // style={{
                    // minHeight: '15vh',
                    // maxHeight: '35vh',
                    // }}
                    >
                        {tareaInfo.usuarios_con_tiempo.length > 0 && (
                            <Grid container xs={12} justifyContent="start" alignItems="start">
                                <Typography variant="subtitle2" gutterBottom style={{ marginBottom: '-0.2em' }} >
                                    En curso por:&nbsp;
                                    {(tareaInfo.usuarios_con_tiempo.slice(0, 3)).map((trabajador, index) => (
                                        <span>{trabajador.label}&nbsp;</span>
                                    ))}
                                </Typography>

                                <>
                                    {tareaInfo.usuarios_con_tiempo.length > 3 && (
                                        <Typography variant="caption" gutterBottom sx={{ fontWeight: 600 }}>
                                            y mas...
                                        </Typography>
                                    )}
                                </>
                            </Grid>
                        )}
                    </Grid>
                )}
                <Typography variant='caption'>
                    Horas totales: {
                        tareaInfo.horas_totales
                            ? `${Math.floor(tareaInfo.horas_totales / 60)}h ${tareaInfo.horas_totales % 60}m`
                            : '0h 0m'
                    }
                </Typography>

            </Grid>


            <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                xs={11.5}
                gap={1}
                style={{ marginTop: '0em' }}
            >
                {/* {console.log(opciones)
                } */}
                {opciones.map((opcion, index) => (
                    <Grid container xs={2} key={index} alignItems='center' justifyContent='center' >
                        <Fab
                            fullWidth
                            size="small"
                            variant='contained'
                            className='button-default'
                            color="primary"
                            key={index}
                            onClick={() => handleEvent(opcion.id_estado)}
                            title={opcion.nombre}
                            disabled={activarBoton(opcion, tareaInfo)} // Aquí puedes implementar la lógica para habilitar o deshabilitar el botón según tu lógica de negocio
                        >

                            {iconMapping[opcion.icono] && (
                                <>
                                    {iconMapping[opcion.icono]}&nbsp;
                                </>
                            )}
                        </Fab>
                    </Grid>
                ))}

                <Typography variant='caption' sx={{ mt: 1 }}>
                    <strong>Creado por: </strong>{tareaInfo.creador}
                </Typography>

            </Grid>





            {/* //desplegable */}
            <Dialog
                open={validar}
                onClose={() => setValidar(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {tareaInfo.id_estado === 4
                        ? "¿Estas seguro de desvalidar esta tarea?"
                        : "¿Estas seguro de validar esta tarea?"
                    }
                </DialogTitle>

                <DialogActions>
                    <Button onClick={() => setValidar(false)} color="primary" autoFocus variant='outlined'>
                        Cancelar
                    </Button>
                    <Button onClick={() => {
                        handleOnChange(tareaInfo.id_estado === 4 ? { id_estado: 3 } : { id_estado: 4 });
                        setValidar(false);
                    }} color="primary" variant='contained'>
                        {tareaInfo.id_estado === 4
                            ? "Desvalidar"
                            : "Validar"
                        }
                    </Button>
                </DialogActions>
            </Dialog>
            {
                tareaEditar == true && (
                    <FormEditarTarea open={tareaEditar} setOpen={setTareaEditar} cargarTareas={cargarTareas} tareaInfo={tareaInfo} setTareaInfo={setTareaInfo}
                        opclientes={opclientes} opTrabajadores={opTrabajadores} trabajadores={tareaInfo.trabajadores} opcionesTipoTareas={opcionesTipoTareas} />
                )
            }
            {/* {
                tareaEditar == true && (
                    <FormEditarTarea open={tareaEditar} setOpen={setTareaEditar} cargarTareas={cargarTareas} tareaInfo={tareaInfo} setTareaInfo={setTareaInfo}
                        opclientes={opclientes} opTrabajadores={opTrabajadores} trabajadores={tarea.trabajadores} />
                )
            } */}
            <Grid container xs={12} justifyContent={'space-between'}>
                <TareaDialog open={open} setOpen={setOpen} tareaInfo={tareaInfo} setTareaInfo={setTareaInfo} opciones={opciones} handleEvent={handleEvent} backgroundCard={backgroundCard} textColor={textColor} setHorasTotales={setHorasTotales} />
            </Grid >
            {
                errorAlert && (
                    <AlertError open={errorAlert} setOpen={setErrorAlert} titulo={"Error"} mensaje={"Minimo 15 minutos de trabajo"} />
                )

            }
        </Grid >


    )
}
